// extracted by mini-css-extract-plugin
export const action = "Styleguide__action__bP7R4";
export const atlasGrotesk = "'AtlasGrotesk'";
export const avatarBig = "Styleguide__avatarBig__nUHm2";
export const avatarMedium = "Styleguide__avatarMedium__40194";
export const avatarSmall = "Styleguide__avatarSmall__Fh293";
export const balloonWrapper = "Styleguide__balloonWrapper__qLYUb";
export const bold = "700";
export const buttonRow = "Styleguide__buttonRow__045Wa";
export const colorSwatch = "Styleguide__colorSwatch__clEjY";
export const colorsHeading = "Styleguide__colorsHeading__CPnmy font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const contentTemplate = "Styleguide__contentTemplate__uSpSL";
export const copiedLabel = "Styleguide__copiedLabel__XhXpR";
export const coral = "Styleguide__coral__oU128";
export const danger = "Styleguide__danger__WZ2sW";
export const dawn = "Styleguide__dawn__EPOtK";
export const downArrow = "Styleguide__downArrow__UccAu";
export const dropdownNav = "Styleguide__dropdownNav__ZVrX+";
export const dusk = "Styleguide__dusk__Q5QGI";
export const fullWidth = "Styleguide__fullWidth__8H7lk";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const hex = "Styleguide__hex__8EbkU font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const leftArrow = "Styleguide__leftArrow__hUhN6";
export const lightAction = "Styleguide__lightAction__npfjM";
export const lightCoral = "Styleguide__lightCoral__g3Eln";
export const lightDanger = "Styleguide__lightDanger__w6-QQ";
export const lightMerlot = "Styleguide__lightMerlot__JYWm7";
export const lightOxford = "Styleguide__lightOxford__cwz8j";
export const lightSuccess = "Styleguide__lightSuccess__e+FFX";
export const lightWarning = "Styleguide__lightWarning__D88Cc";
export const logoWrapper = "Styleguide__logoWrapper__TREPK";
export const medium = "500";
export const merlot = "Styleguide__merlot__bXclH";
export const midnight = "Styleguide__midnight__HeTaX";
export const navButton = "Styleguide__navButton__fQiqK";
export const navList = "Styleguide__navList__3hJAN";
export const noon = "Styleguide__noon__WCPCh";
export const oxford = "Styleguide__oxford__mHIYw";
export const post = "Styleguide__post__F66-d";
export const regular = "400";
export const salt = "Styleguide__salt__K5R7i";
export const sans = "'sans'";
export const satin = "Styleguide__satin__VjFkf";
export const secondaryNavButton = "Styleguide__secondaryNavButton__RH4Q9";
export const semibold = "600";
export const serif = "'serif'";
export const sgBalloons = "Styleguide__sgBalloons__cfkyh";
export const sgCharts = "Styleguide__sgCharts__xvA1N";
export const sgExample = "Styleguide__sgExample__Eiu4s";
export const sgFeed = "Styleguide__sgFeed__MsJlT";
export const sgForm = "Styleguide__sgForm__ABpM6";
export const sgHeading = "Styleguide__sgHeading__N2okX";
export const sgIcons = "Styleguide__sgIcons__rZpQp";
export const sgLayout = "Styleguide__sgLayout__72CE7";
export const sgLayouts = "Styleguide__sgLayouts__HU+ev";
export const sgMainHeading = "Styleguide__sgMainHeading__6ZvY0";
export const sgModules = "Styleguide__sgModules__r-MOj";
export const sgNav = "Styleguide__sgNav__a2E6R";
export const sgOrganisms = "Styleguide__sgOrganisms__118IE";
export const sgSecondaryNav = "Styleguide__sgSecondaryNav__JztC2";
export const sgSection = "Styleguide__sgSection__P1-g7";
export const sgWorkspace = "Styleguide__sgWorkspace__mNdD7";
export const shade = "Styleguide__shade__BMUch";
export const shadow = "Styleguide__shadow__sF5BP";
export const shale = "Styleguide__shale__Wngp+";
export const silver = "Styleguide__silver__ZsVf9";
export const slate = "Styleguide__slate__Qnf-o";
export const smoke = "Styleguide__smoke__3g5f9";
export const snow = "Styleguide__snow__D18lb";
export const stone = "Styleguide__stone__vFUuO";
export const storm = "Styleguide__storm__WNuT-";
export const styleGuide = "Styleguide__styleGuide__L5B+M";
export const success = "Styleguide__success__8W+Rq";
export const textCenter = "Styleguide__textCenter__ofLxa";
export const typeStyles = "Styleguide__typeStyles__iP82t";
export const typeface = "Styleguide__typeface__ui8fG";
export const visible = "Styleguide__visible__vkns4";
export const warning = "Styleguide__warning__hubBs";
export const withDropdown = "Styleguide__withDropdown__KhLTE";